// extracted by mini-css-extract-plugin
module.exports = {"submitImage":"_1rw3t","trackingPixel":"_1_6Vj"};